<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><a id="page-6"></a><span class="smallcaps">TABLE OF CONTENTS</span></span></p>
<p class="toc-entry">   <a href="#/xhtml/chapter01#ch01">I  Ambiguity and Freedom</a></p>
<p class="toc-entry">  <span href="#/xhtml/chapter02#ch02" title="Link target outside of Sample">II  Personal Freedom and Others</span></p>
<p class="toc-entry"> <span href="#/xhtml/chapter03" title="Link target outside of Sample">III The Positive Aspect of Ambiguity</span></p>
<p class="toc-entry"> </p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#sec01" title="Link target outside of Sample">1. The Aesthetic Attitude</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#sec02" title="Link target outside of Sample">2. Freedom and Liberation</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#sec03" title="Link target outside of Sample">3. The Antinomies of Action</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#sec04" title="Link target outside of Sample">4. The Present and the Future</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#sec05" title="Link target outside of Sample">5. Ambiguity</span></p>
<p class="toc-entry2"><span href="#/xhtml/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-entry2"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?c1b1a7de